<template>
  <div v-if="apiUser && apiUser.isCustomerAdmin" class="admin-page__content">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <h2 class="mb-0">
          {{ $t("logOperaci") }}
        </h2>
        {{ $t("proZakaznika") }} {{ storedCustomer.customerName }}
      </div>
      <!--button
        class="btn btn-primary d-flex align-items-center justify-content-center">
        <div class="atom-icon">
          <img src="@/assets/icons/actions/ico-btn-ulozit.svg">
        </div>
        {{ $t("ulozitZmeny") }}
      </button-->
    </div>
    <div class="mt-4">
      <RadioHelp
        :article-link="'/admin/customer/logs'"
        :show="showHelp"
        @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
        @update-show-radio-help="showRadioHelp($event)"
      />
      <div v-if="radioSlides && radioSlides.length > 0" class="position-relative mt-6">
        <RadioOpenClose
          :custom-class="'d-flex align-items-end radio--default'"
          :radio-slides="radioSlides"
          :show="showHelp"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <CustomTableAjax
        v-if="apiUser && endpoint"
        :columns="[
          {
            name: 'timestamp',
            class: 'timestamp',
            sortable: true,
            filter: 'dateTime',
            separator: '<br />'
          },
          {
            name: 'DESCRIPTION',
            sortable: true,
            filter: 'replaceVariables',
            class: 'description'
          },
          { name: 'level', sortable: true },
          { name: 'projectId', sortable: true },
          { name: 'customerId', sortable: true },
          { name: 'originator', sortable: true }
        ]"
        :endpoint="endpoint"
        :full-width="true"
        :items="audits"
        class="logs mobile-scrollable"
      />
    </div>
  </div>
  <div v-else>
    {{ $t("nemateOpravneniProhlizetTutoStranku") }}
  </div>
</template>

<script>
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import CustomTableAjax from "@/components/custom-table/table-ajax.vue"
import { useCustomerStore } from "@/store/modules/customer"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    RadioHelp,
    RadioOpenClose,
    CustomTableAjax
  },
  props: {
    customer: Object
  },
  setup() {
    const configStore = useConfigStore()
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()

    return { configStore, customerStore, authStore }
  },
  data() {
    return {
      endpoint: false,
      radioSlides: [],
      showHelp: true,
      audits: []
    }
  },
  computed: {
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    apiUser() {
      return this.authStore.apiUser
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    storedCustomer() {
      /** set endpoint if is not set */

      if (!this.endpoint) {
        this.endpoint = process.env.VUE_APP_API + "/audits/customers/" + this.storedCustomer.customerId
      }
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.showHelp = !this.radioDisabled
    if (this.storedCustomer) {
      this.endpoint = process.env.VUE_APP_API + "/audits/customers/" + this.storedCustomer.customerId
    }
    console.log("logs vue mounted 2 endpoint " + this.endpoint)
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    }
  }
}
</script>

<style lang="scss" scoped></style>
